module.exports = __webpack_public_path__ + "images/blog_guide/flow03_d2012550afc0b2a04ee5b24ef0da2453.png";